import { FormattedHTMLMessage } from "react-intl";

import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";

import { DEFAULT_LOCALE } from "../../../constants";
import { type FormFieldComponentProps } from "../../../lib/types/types";
import { DateComponent } from "../../DateComponent/DateComponent";

type Props = Omit<FormFieldComponentProps, "isErrored"> & {
  locale: string;
  /**
   * @deprecated deprecated in favor of using errorId instead
   */
  isErrored?: boolean;
};

export const ActiveDutyStartDateComponent = ({
  onChange,
  errorId,
  isErrored = !!errorId,
  value = "2000-01-01",
  locale = DEFAULT_LOCALE,
  disabled = false,
}: Props) => {
  const isFieldHidden = getFieldConfigByFieldId("activeDutyStartDate")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <DateComponent
      value={value}
      label={
        <FormattedHTMLMessage id="activeDutyStartDate" defaultMessage="Active Duty Start Date" />
      }
      explanation={
        <FormattedHTMLMessage
          id="verificationPurposesOnly"
          defaultMessage="Used for verification purposes only"
        />
      }
      onChange={onChange}
      fieldName="activeDutyStartDate"
      fieldId="sid-active-duty-start-date"
      locale={locale}
      isErrored={isErrored}
      disabled={disabled}
      errorMsg={
        <FormattedHTMLMessage id={`errorId.${errorId}`} defaultMessage="Invalid start date" />
      }
    />
  );
};
